import { render } from "./add_oncology_procedures_modal.vue?vue&type=template&id=faa2f914&scoped=true"
import script from "./add_oncology_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_oncology_procedures_modal.vue?vue&type=script&lang=js"

import "./add_oncology_procedures_modal.vue?vue&type=style&index=0&id=faa2f914&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa2f914"]])

export default __exports__